import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";
import { ButtonLoader4 } from "../../components/ButtonLoader";

const ForgotPassword = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const response = await axios.post(
          `${BASE_URL}/api/password-reset/`,
          values
        );
        Swal.fire({
          icon: "success",
          text: response.data.message || "Password reset link sent!",
        });
        resetForm();
      } catch (error) {
        Swal.fire({
          icon: "error",
          text:
            error.response?.data?.message ||
            error.response?.data?.email ||
            "Something went wrong! Try again.",
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="w-full flex justify-center items-center h-[100vh]">
      <div className="lg:w-[40%] bg-[#FFF5CE] rounded-lg shadow-lg md:p-12 p-4 flex flex-col items-center justify-center">
        <img className=" w-[100px] " src="/images/main-logo-2.png" alt="" />
        <h2 className="text-3xl font-bold mb-3 text-center">Forgot Password</h2>
        <p className="text-center">
          Enter your Email for the Verification Process
        </p>

        <form
          onSubmit={formik.handleSubmit}
          className="flex flex-col gap-3 w-full"
        >
          <label className="font-normal">Email</label>
          <input
            type="email"
            placeholder="Email Address"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full p-2 border outline-none h-[50px] px-4 rounded-lg"
          />
          {formik.errors.email && formik.touched.email && (
            <p className="text-red-500 text-[12px]">{formik.errors.email}</p>
          )}

          <div className="flex items-center justify-end w-full">
            <button
              type="submit"
              className="flex items-center justify-center w-full h-[50px] bg-[#586989] text-white p-2 rounded font-medium mt-4"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? <ButtonLoader4 /> : "Send"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
